import { formatToPKR } from "@/lib/helper";

interface DonationSummaryProps {
  readonly data: any;
  readonly isLoading: boolean;
}

export default function DonationSummary({ data, isLoading }: DonationSummaryProps) {
  if (isLoading) {
    return (
      <div className="space-y-3">
        <div className="grid gap-2 grid-cols-2 sm:grid-cols-4">
          <div className="animate-pulse bg-gray-100 rounded-md p-3 h-20"></div>
          <div className="animate-pulse bg-gray-100 rounded-md p-3 h-20"></div>
          <div className="animate-pulse bg-gray-100 rounded-md p-3 h-20"></div>
          <div className="animate-pulse bg-gray-100 rounded-md p-3 h-20"></div>
        </div>
      </div>
    );
  }

  // Map API summary fields
  const totalAmount    = data?.summary?.total_amount    || 0;
  const totalSubAmount = data?.summary?.total_sub_amount || 0;
  const totalTaxAmount = data?.summary?.total_tax_amount || 0;
  const successAmount  = data?.summary?.success_amount  || 0;
  const failedAmount   = data?.summary?.failed_amount   || 0;

  const cards = [
    {
      label: "Total Sales",
      value: totalAmount,
      color: "blue",
      icon: "fa-chart-line",
    },
    {
      label: "Subtotal",
      value: totalSubAmount,
      color: "indigo",
      icon: "fa-coins",
    },
    {
      label: "Total Tax",
      value: totalTaxAmount,
      color: "purple",
      icon: "fa-percentage",
    },
    {
      label: "Success",
      value: successAmount,
      color: "green",
      icon: "fa-check-circle",
    },
    {
      label: "Failed",
      value: failedAmount,
      color: "red",
      icon: "fa-times-circle",
    },
  ].filter((c) => c.value > 0 || c.label === "Total Sales"); // always show Total Sales

  const colorMap: Record<string, string> = {
    blue:   "bg-blue-50 border-blue-200 text-blue-600",
    indigo: "bg-indigo-50 border-indigo-200 text-indigo-600",
    purple: "bg-purple-50 border-purple-200 text-purple-600",
    green:  "bg-green-50 border-green-200 text-green-600",
    red:    "bg-red-50 border-red-200 text-red-600",
  };

  return (
    <div className="space-y-3">
      <div className="grid gap-2 grid-cols-2 sm:grid-cols-3 md:grid-cols-5">
        {cards.map((card) => (
          <div
            key={card.label}
            className={`${colorMap[card.color] ?? "bg-gray-50 border-gray-200 text-gray-600"} border rounded-md p-2.5`}
          >
            <div className="flex items-center justify-between mb-1">
              <p className="text-xs font-medium">{card.label}</p>
              <i className={`fa-solid ${card.icon} text-xs`}></i>
            </div>
            <p className="text-lg font-bold leading-tight">
              {formatToPKR(card.value)}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
